import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import { forwardRef } from 'react';

export type IButtonProps = Omit<MuiButtonProps, 'ref' | 'name'> & {
    name: string;
};

export const Button = forwardRef<HTMLButtonElement, IButtonProps>(function InnerButton({ hidden, ...props }, ref) {
    return <MuiButton {...props} ref={ref} hidden={hidden} style={{ display: hidden ? 'none' : '' }} />;
});
